import { Injectable } from '@angular/core';
import { PHBHPApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/lib/ph-bhp-api.service';

@Injectable({
  providedIn: 'root'
})
export class CampaignsService {

  constructor( 
    private service: PHBHPApiService
  ) { 
  }
  
  getCampaigns() {
    return this.service.getApi(`Campaigns/GetCampaigns`, true);
  }

  getCampaignsByUserId(userId: number) {
    return this.service.getApi(`Campaigns/GetCampaignsByUserId/${userId}`, true);
  }

  updateCampaignVisibility(campaign: any) {
    return this.service.postApi(`Campaigns/UpdateCampaignVisibility`, campaign, true);
  }
}
